{
  "global": {
    "backToHome": "Volver a la página de inicio",
    "errors": {
      "unhandledError": "Se ha producido un error no controlado",
      "serverError": "Se ha producido un error. Vuelva a intentarlo más tarde.",
      "accessDenied": "Acceso denegado"
    }
  },
  "header": {
    "logoAlt": "CIM Bank - Banca Privada Suiza",
    "btnLogout": "Desconección",
    "btnMessages": "Mensajes",
    "btnRegistrations": "Mis inscripciones"
  },
  "footer": {
    "copyright": "© CIM Banque SA - Ginebra, Lugano, Wollerau - Suiza",
    "contactFormLabel": "Formulario de contacto",
    "contactFormSubtitle": "Utilice este formulario para ponerse en contacto con uno de nuestros especialistas.",
    "relationshipManagerLabel": "Mi oficial de cuenta",
    "contactHours": "De lunes a viernes, de 8:30 a 18:30",
    "contactPhone": "+41 (0)58 225 50 50"
  },
  "modal": {
    "confirmButton": "Ok",
    "cancelButton": "Cancelar",
    "remark": "Nota"
  },
  "attachment": {
    "fileNoName": "Fichero sin nombre",
    "errors": {
      "noMultipleFilesAllowed": "Sólo se puede subir un archivo a la vez",
      "allowedTypes": "Sólo se admiten imágenes o PDF",
      "unhandledError": "Se ha producido un error al subir el archivo. Verifique el tamaño del archivo (máximo 8 MB) e inténtelo nuevamente más tarde."
    }
  },
  "gender": {
    "gender": "Género",
    "male": "Hombre",
    "female": "Mujer",
    "genderError": "El género es obligatorio"
  },
  "maritalStatusEnum": {
    "single": "Soltero/a",
    "married": "Casado/a",
    "divorced": "Divorciado/a",
    "widower": "Viudo/a",
    "civilUnion": "Unión civil"
  },
  "counterpartyOperationTypeEnum": {
    "import": "Importar",
    "export": "Exportar",
    "intermediation": "Intermediación",
    "fees": "Tasas",
    "logisticsAndTransport": "Logística y transporte",
    "other": "Otro"
  },
  "counterpartyCashFlowTypeEnum": {
    "incoming": "Entrante",
    "outgoing": "Saliente"
  },
  "signatureTypeEnum": {
    "signature": "Firma",
    "signatureIndividual": "Individual",
    "signatureCollective": "Colectiva",
    "none": "Ninguna"
  },
  "validation": {
    "onlyChars": "Este campo sólo debe contener caracteres o números"
  },
  "messages": {
    "messagesDialogTitle": "Mensajes",
    "messageBy": "De {username}",
    "messageOn": "el {date}",
    "messageSeen": "Visto por {username} el {date}",
    "addMessage": "Escriba un mensaje...",
    "addAttachment": "Adjuntar un archivo",
    "submit": "Enviar"
  },
  "login": {
    "email": "E-mail",
    "btnRequestAccess": "Obtener un enlace seguro",
    "openAccount": "¿Abrir una cuenta?",
    "description": "Le enviaremos un correo electrónico con un enlace que le proporcionará acceso seguro a nuestra plataforma.",
    "successMessage": "Por favor, revise sus correos electrónicos e inicie sesión utilizando el enlace seguro.",
    "errors": {
      "invalidToken": "El enlace no es válido. Introduzca su dirección de correo electrónico y le enviaremos un correo con un enlace que le proporcionará acceso seguro a nuestra plataforma.",
      "genericError": "Ha ocurrido un error. Inténtelo nuevamente más tarde.",
      "email": "Correo electrónico obligatorio",
      "emailInvalid": "El correo electrónico debe ser válido",
      "noRecipientFound": "No se ha encontrado este correo electrónico"
    }
  },
  "open": {
    "btnBack": "Volver",
    "btnNext": "Siguiente",
    "btnSubmit": "Enviar",
    "yes": "Sí",
    "no": "No",
    "tabs": {
      "accountType": "Tipo de cuenta",
      "individual": {
        "contactInformation": "Contacto personal",
        "additionalInformation": "Información adicional",
        "confirmation": "Confirmación"
      },
      "company": {
        "companyInformation": "Su empresa",
        "contactInformation": "Información personal",
        "additionalInformation": "Información adicional",
        "confirmation": "Confirmación"
      }
    },
    "accountType": {
      "title": "Seleccione un tipo de cuenta",
      "subtitle": "Seleccione el tipo de cuenta que desea abrir.",
      "optionIndividual": "Cuenta personal",
      "optionIndividualInformation": "Coste de apertura de <span class=\"cim-pink\">90</span> CHF/EUR/USD",
      "optionCorporate": "Cuenta de empresa",
      "optionCorporateInformation": "Coste de apertura de <span class=\"cim-pink\">500</span> CHF/EUR/USD",
      "warningPotential": ""
    },
    "individual": {
      "contactInformation": {
        "title": "Introduzca sus datos personales y de contacto",
        "firstName": "Nombre",
        "middleName": "Segundo nombre",
        "lastName": "Apellidos",
        "email": "E-mail",
        "repeatEmail": "Repetir e-mail",
        "mobilePhone": "Teléfono móvil",
        "repeatMobilePhone": "Repetir teléfono móvil"
      },
      "additionalInformation": {
        "title": "Introduzca información adicional",
        "birthDate": "Fecha de nacimiento",
        "cityOfBirth": "Ciudad de nacimiento",
        "countryOfBirth": "País de nacimiento",
        "countryOfResidence": "País de residencia",
        "nationality": "Nacionalidad",
        "preferredLanguage": "Idioma preferido"
      },
      "confirmation": {
        "greetings": "¡Muchas gracias!",
        "messageInvited": "Le hemos enviado un correo electrónico con más instrucciones para completar su solicitud de cuenta. Siga el enlace del correo electrónico para establecer su contraseña e iniciar sesión en MyCIM. Si no lo tiene, compruebe su carpeta de correo no deseado.",
        "message": "Un gestor de cuentas le contactará próximamente para iniciar el proceso de apertura."
      },
      "errors": {
        "firstName": "El nombre es obligatorio",
        "lastName": "Los apellidos son obligatorios",
        "email": "El correo electrónico es obligatorio",
        "emailInvalid": "El correo electrónico debe ser válido",
        "emailsDifferent": "Los correos electrónicos deben coincidir",
        "mobilePhone": "El teléfono móvil es obligatorio y debe ser válido (ej: +41XXXXXXXXX)",
        "mobilePhonesDifferent": "Los teléfonos móviles deben coincidir",
        "birthDate": "La fecha de nacimiento es obligatoria y debe ser válida",
        "birthDateFuture": "La fecha de nacimiento no puede ser posterior a hoy",
        "cityOfBirth": "La ciudad de nacimiento es obligatoria",
        "countryOfBirth": "El país de nacimiento es obligatorio",
        "countryOfResidence": "La ciudad de residencia es obligatoria",
        "nationality": "La nacionalidad es obligatoria",
        "preferredLanguage": "El idioma preferido es obligatorio"
      }
    },
    "company": {
      "companyType": {
        "domiciliaryTitle": "Empresa no operativa",
        "domiciliarySubtitle": "Titularidad de participaciones o activos.",
        "operatingTitle": "Empresa operativa",
        "operatingSubtitle": "Prestación de servicios o realización de negocios.",
        "otherTitle": "Otro",
        "otherSubtitle": "Fideicomiso, fundación o asociación, póliza de seguro."
      },
      "roleInCompany": {
        "noRole": "Sin función formal en la estructura",
        "beneficial": "Beneficiario final (UBO)",
        "shareholder": "Accionista",
        "signatory": "Firmante",
        "introducingPartner": "Socio señalador",
        "director": "Director"
      },
      "companyInformation": {
        "title": "Seleccione su tipo de empresa",
        "companyName": "Nombre de la empresa",
        "companyTypeRemark": "Justificación de las actividades no operativas",
        "incorporationCountry": "País de constitución",
        "contactTheBank": "Póngase en contacto con el banco para continuar con su procedimiento de apertura"
      },
      "contactInformation": {
        "title": "Introduzca sus datos personales",
        "info": "Indique sus datos de contacto para que podamos ponernos en contacto con usted.",
        "firstName": "Nombre",
        "lastName": "Apellidos",
        "role": "¿Cuál es su papel en la empresa?",
        "cimBanqueCustomer": "¿Es usted cliente de CIM Banque?",
        "accountNumber": "¿Cuál es su número de cuenta?",
        "howHeard": "¿Cómo ha conocido CIM Banque?"
      },
      "additionalInformation": {
        "title": "Introduzca sus datos de contacto",
        "email": "E-mail",
        "repeatEmail": "Repita su e-mail",
        "mobilePhone": "Teléfono móvil",
        "repeatMobilePhone": "Repita su teléfono móvil",
        "preferredLanguage": "Idioma preferido"
      },
      "confirmation": {
        "greetings": "¡Muchas gracias!",
        "messageInvited": "Le hemos enviado un correo electrónico con más instrucciones para completar su solicitud de cuenta. Siga el enlace del correo electrónico para establecer su contraseña e iniciar sesión en MyCIM. Si no lo tiene, compruebe su carpeta de correo no deseado.",
        "message": "Un gestor de cuentas le contactará próximamente para iniciar el proceso de apertura."
      },
      "errors": {
        "companyName": "El nombre de la empresa es obligatorio",
        "incorporationCountry": "El país de constitución es obligatorio",
        "role": "Función obligatoria",
        "alreadyCustomer": "Este campo es obligatorio",
        "accountNumber": "El número de cuenta es obligatorio",
        "firstName": "El nombre es obligatorio",
        "lastName": "El apellido es obligatorio",
        "email": "El correo electrónico es obligatorio",
        "emailInvalid": "El correo electrónico debe ser válido",
        "emailsDifferent": "Los correos electrónicos deben coincidir",
        "mobilePhone": "El teléfono móvil es obligatorio y debe ser válido (ej: +41XXXXXXXXX)",
        "mobilePhonesDifferent": "Los móviles deben coincidir",
        "preferredLanguage": "El idioma preferido es obligatorio",
        "companyTypeRemark": "La justificación es obligatoria"
      }
    }
  },
  "register": {
    "btnBack": "Volver",
    "btnPrevious": "Anterior",
    "btnCancel": "Cancelar",
    "btnNext": "Siguiente",
    "btnContinue": "Seguir",
    "btnSubmit": "Enviar",
    "btnSave": "Guardar",
    "yes": "Sí",
    "no": "No",
    "tabs": {
      "individualAccountUsage": "Finalidad de la cuenta",
      "individualInformation": "Información personal",
      "familyAndJob": "Familia y profesión",
      "contract": "Contrato",
      "yourDocuments": "Sus documentos",
      "companyAccountUsage": "Finalidad de la cuenta",
      "companyInformation": "Información sobre la empresa",
      "companyStructure": "Estructura de la empresa",
      "companyTransaction": "Información sobre las transacciones",
      "companyCounterparties": "Contrapartes",
      "underReview": "En revisión",
      "refused": "Rechazado",
      "initialDeposit": "Depósito inicial"
    },
    "prospectSelection": {
      "title": "Inscripciones pendientes",
      "continue": "Seguir",
      "openAnotherAccount": "Abrir otra cuenta"
    },
    "individualAccountUsage": {
      "title": "La finalidad de la cuenta será {displayName}.",
      "accountUsages": {
        "savingsAndInvestments": "Ahorro e inversión",
        "currentAccount": "Cuenta corriente",
        "other": "Otro, especifique"
      }
    },
    "companyAccountUsage": {
      "title": "La finalidad de la cuenta será {displayName}",
      "accountUsages": {
        "commercialActivity": "Actividad comercial",
        "savingsAndInvestments": "Ahorro e inversión",
        "currentAccount": "Cuenta corriente",
        "other": "Otro, especifique"
      }
    },
    "individualInformation": {
      "title": "Rellene los datos de la cuenta personal de {displayName}",
      "subtitle": "Estimado {username}, necesitamos que responda a las siguientes preguntas",
      "addressLine1": "Dirección",
      "zipCode": "Código postal",
      "city": "Ciudad",
      "residenceCountryIsoCode": "País de residencia",
      "passportNumber": "Número del pasaporte",
      "passportExpirationDate": "Fecha de caducidad del pasaporte",
      "taxationCountryIsoCode": "País de fiscalización",
      "tinNumber": "Número NIF",
      "hasTinNumber": "No tengo número NIF",
      "relationWithUSA": "Relación con los Estados Unidos",
      "isLinkedToUnitedStates": "¿Eres americano?",
      "hasUSPassportOrGreenCard": "¿Tiene pasaporte estadounidense o tarjeta verde?",
      "hasSpentSubstantialTimeInUS": "¿Ha pasado más de 90 días al año en los Estados Unidos?",
      "isUSResidentForAnyOtherReason": "¿Tiene propiedades en los Estados Unidos?",
      "errors": {
        "addressLine1": "La dirección es obligatoria",
        "zipCode": "El código postal es obligatorio",
        "city": "La ciudad es obligatoria",
        "passportNumber": "El número de pasaporte es obligatorio",
        "passportExpirationDate": "El pasaporte debe tener una fecha de caducidad válida",
        "passportExpirationDateOutdated": "La fecha debe ser posterior a la de hoy",
        "residenceCountryIsoCode": "El país es obligatorio",
        "taxationCountryIsoCode": "El país de fiscalización es obligatorio",
        "tinNumber": "El número NIF es obligatorio",
        "isLinkedToUnitedStates": "El campo relativo a Estados Unidos es obligatorio",
        "hasUSPassportOrGreenCard": "Seleccione un valor",
        "hasSpentSubstantialTimeInUS": "Seleccione un valor",
        "isUSResidentForAnyOtherReason": "Seleccione un valor"
      }
    },
    "individualFamily": {
      "family": "Familia de {displayName}",
      "maritalStatus": "Estado civil",
      "spouse": "Cónyuge / pareja",
      "needJointAccount": "Necesito una cuenta conjunta",
      "children": "Niños",
      "addChild": "Agregar un niño",
      "job": "Empleo de {displayName}",
      "roleLabel": "Empleo / ocupación 1/2",
      "jobLabel": "Empleo / ocupación 2/2",
      "workplaceCountry": "País del lugar de trabajo",
      "firstName": "Nombre",
      "lastName": "Apellido (apellido de soltera)",
      "errors": {
        "maritalStatus": "El estado civil es obligatorio",
        "job": "La actividad es obligatoria",
        "workplaceCountryIsoCode": "El lugar de trabajo es obligatorio",
        "partnerFirstName": "El nombre es obligatorio",
        "partnerLastName": "El apellido es obligatorio"
      }
    },
    "individualInProgressModal": {
      "title": "Gracias por su información",
      "subtitle": "Sus datos se han registrado correctamente",
      "message": "Asegúrese de que todos sus datos personales son correctos antes de continuar, ya que no podrá modificarlos una vez que pase a la siguiente etapa"
    },
    "individualContract": {
      "title": "Contrato, condiciones generales",
      "subtitle": "Estimado {username}, está a punto de firmar su contrato. Por favor, tome su tiempo para leerlo.",
      "openAndRead": "Abrir y leer el borrador de mi contrato",
      "contractAgreement": "He leído y acepto mi contrato",
      "termsAgreement": "He leído y acepto las <a class=\"cim-link\" target=\"_blank\" href=\"https://assets.cimbanque.com/documents/06_general-terms-and-conditions-en.pdf\">condiciones generales</a> de CIM Banque",
      "feesAgreement": "He leído y acepto las <a class=\"cim-link\" target=\"_blank\" href=\"https://www.cimbanque.com/fees-for-private-accounts\">tasas y comis</a> de CIM Banque",
      "hasReadAndAgreeWithRisksInvolvedInTradingFinancialInstruments": "He leído y acepto los <a class=\"cim-link\" target=\"_blank\" href=\"https://assets.cimbanque.com/documents/special_risks_security_trading.pdf\">riesgos asociados a la negociación de instrumentos financieros</a>",
      "errors": {
        "contractAgreement": "Este campo es obligatorio",
        "termsAgreement": "Este campo es obligatorio",
        "feesAgreement": "Este campo es obligatorio",
        "hasReadAndAgreeWithRisksInvolvedInTradingFinancialInstruments": "Este campo es obligatorio"
      }
    },
    "individualDocuments": {
      "title": "Descargar documentos de {displayName}",
      "certificateOfResidence": "Certificado de residencia",
      "certificateOfResidenceSubtitle": "Arrastre y suelte o pinche para descargar el <span class='document-subtitle-string'>Certificado de residencia*</span> de este titular",
      "passport": "Pasaporte",
      "passportSubtitle": "Arrastre y suelte, o pinche para descargar el <span class='document-subtitle-string'>Pasaporte</span> de este titular",
      "datedLess": "* Con fecha de los últimos 12 meses y expedido por una autoridad gubernamental competente - Tenga en cuenta que no se aceptan facturas de servicios públicos ni extractos bancarios",
      "errors": {
        "allowedTypes": "Sólo se admiten imágenes o PDF",
        "unhandledError": "Se ha producido un error al subir el archivo. Verifique el tamaño del archivo (máximo 8 MB) e inténtelo nuevamente más tarde."
      }
    },
    "companyInformation": {
      "title": "Introduzca los datos de su empresa para {displayName}",
      "addressLine1": "Dirección",
      "addressLine2": "Dirección adicional",
      "zipCode": "Código postal",
      "city": "Ciudad",
      "residenceCountryIsoCode": "País",
      "website": "Página web",
      "shareCapital": "Capital social",
      "shareCapitalCurrencyIsoCode": "Moneda",
      "dateOfIncorporation": "Fecha de incorporación",
      "countryOfIncorporation": "País de incorporación",
      "roleLabel": "Actividad 1/2",
      "activityId": "Actividad 2/2",
      "activityRemark": "Descripción de la actividad",
      "hasBalanceSheetFinancialStatement": "¿Dispone la empresa de un reporte financiero auditado?",
      "hasExternalAccounting": "¿Dispone la empresa de contabilidad externa?",
      "hasPhysicalOffice": "¿Tiene la empresa oficinas físicas en {countryName}?",
      "officeCountryIsoCode": "País donde se encuentran las oficinas",
      "numberOfEmployees": "Número de empleados en las oficinas",
      "hasEmployeesInPlaceOfIncorporation": "¿Tiene la empresa empleados en {countryName}?",
      "hasDirectorInPlaceOfIncorporation": "¿Tiene la empresa un director en {countryName}?",
      "holdAnOperatingCompany": "¿Posee la empresa una sociedad de explotación activa?",
      "hasReadAndAgreeWithTermsAndConditions": "He leído y acepto las <a class=\"cim-link\" target=\"_blank\" href=\"https://assets.cimbanque.com/documents/2021_mycim_general-terms-and-conditions-en.pdf\">condiciones generales</a> de CIM Banque",
      "hasReadAndAgreeWithFeesAndCommissions": "He leído y acepto las <a class=\"cim-link\" target=\"_blank\" href=\"https://www.cimbanque.com/fees-for-company-accounts\">tasas y comis</a> de CIM Banque",
      "hasReadAndAgreeWithRisksInvolvedInTradingFinancialInstruments": "He leído y acepto los <a class=\"cim-link\" target=\"_blank\" href=\"https://www.cimbanque.com/docs/default-source/pdf/special_risks_security_trading.pdf\">riesgos asociados a la negociación de instrumentos financieros</a>",
      "errors": {
        "addressLine1": "La dirección es obligatoria",
        "zipCode": "El código postal es obligatorio",
        "city": "La ciudad es obligatoria",
        "residenceCountryIsoCode": "El país es obligatorio",
        "shareCapital": "El capital social es obligatorio",
        "shareCapitalCurrencyIsoCode": "La moneda es obligatorio",
        "dateOfIncorporation": "La fecha de constitución es obligatoria y debe ser válida",
        "pastDateOfIncorporation": "La fecha de incorporación debe ser anterior a hoy",
        "countryOfIncorporation": "El país de constitución es obligatorio",
        "officeCountryIsoCode": "Es obligatorio indicar el país en el que se encuentran las oficinas",
        "numberOfEmployees": "El número de empleados es obligatorio",
        "activityId": "La actividad es obligatoria",
        "activityRemark": "La descripción de la actividad es obligatoria si la actividad es Otro",
        "hasBalanceSheetFinancialStatement": "Este campo es obligatorio",
        "hasExternalAccounting": "Este campo es obligatorio",
        "hasPhysicalOffice": "Este campo es obligatorio",
        "hasEmployeesInPlaceOfIncorporation": "Este campo es obligatorio",
        "hasDirectorInPlaceOfIncorporation": "Este campo es obligatorio",
        "hasReadAndAgreeWithTermsAndConditions": "Esta declaración es obligatoria",
        "hasReadAndAgreeWithFeesAndCommissions": "Esta declaración es obligatoria",
        "hasReadAndAgreeWithRisksInvolvedInTradingFinancialInstruments": "Esta declaración es obligatoria",
        "holdAnOperatingCompany": "Este campo es obligatorio"
      }
    },
    "companyStructure": {
      "signatory": "Firmante",
      "ubo": "Beneficiario final (UBO)",
      "ownershipTotalTitle": "Plena propiedad",
      "ownershipTotalWarning": "La suma de las participaciones debe ser igual al 100%",
      "ownershipTitle": "Participación",
      "noUBO": "No se han añadido beneficiarios finales",
      "noSignatories": "No se han añadido firmantes",
      "addNewEntity": "Añadir un UBO o un firmante",
      "incompleteRelatedEntites": "Al menos un beneficiario final o firmante está incompleto",
      "title": {
        "companyStructure": "Describa la estructura de la empresa",
        "relativeEntitySelection": "Personas implicadas en la empresa",
        "relativeEntityBeneficialOwnerAdd": "Añadir un beneficiario final (UBO) para {displayName}",
        "relativeEntityBeneficialOwnerEdit": "Editar beneficiario final (UBO) para {displayName}",
        "relativeEntitySignatoryAdd": "Añadir un firmante para {displayName}",
        "relativeEntitySignatoryEdit": "Modificar un firmante para {displayName}",
        "relativeEntityPowerOfAttorneyAdd": "Añadir un firmante para {displayName}",
        "relativeEntityPowerOfAttorneyEdit": "Modificar un firmante para {displayName}"
      },
      "deleteModal": {
        "UBOTitle": "¿Está seguro de que desea eliminar este beneficiario final?",
        "UBOSubtitle": "Está a punto de eliminar este beneficiario final: {entityName}",
        "signatoryTitle": "¿Está seguro de que desea eliminar a este firmante?",
        "signatorySubtitle": "Está a punto de eliminar a este firmante: {entityName}"
      }
    },
    "companyRelativeEntitySelection": {
      "addUbo": "Añadir un beneficiario final",
      "addUboInformation": "Añadir un beneficiario final (UBO)",
      "addSignatory": "Añadir un firmante",
      "addSignatoryInformation": "Añadir un firmante (Representante)"
    },
    "companyRelativeEntity": {
      "ownership": "Propietario",
      "percentageOfOwnership": "Porcentaje de propiedad",
      "personalInformation": "Información personal",
      "firstName": "Nombre",
      "middleName": "Segundo nombre",
      "lastName": "Apellidos",
      "nationalityIsoCode": "Nacionalidad",
      "birthDate": "Fecha de nacimiento",
      "cityOfBirth": "Ciudad de nacimiento",
      "countryOfBirthIsoCode": "País de nacimiento",
      "contactInformation": "Datos de contacto",
      "addressLine1": "Dirección",
      "addressLine2": "Dirección adicional",
      "zipCode": "Código postal",
      "city": "Ciudad",
      "residenceCountryIsoCode": "País de residencia",
      "mobilePhoneNumber": "Número de teléfono",
      "email": "E-mail",
      "passportInformation": "Información sobre el pasaporte",
      "passportNumber": "Número de pasaporte",
      "passportExpirationDate": "Fecha de caducidad del pasaporte",
      "jobInformation": "Información sobre la actividad",
      "role": "Actividad 1/2",
      "activityId": "Actividad 2/2",
      "workplaceCountryIsoCode": "País de actividad",
      "isPoliticallyExposed": "¿Está el beneficiario final (UBO) políticamente expuesto?",
      "isDirector": "¿El director forma parte de la estructura de la empresa?",
      "taxationInformation": "Información fiscal",
      "taxationCountryIsoCode": "País de imposición",
      "tinNumber": "Número NIF",
      "hasTinNumber": "No tengo número NIF",
      "isLinkedToUnitedStates": "¿Tiene el beneficiario final algún vínculo con los Estados Unidos?",
      "hasUSPassportOrGreenCard": "¿Tiene pasaporte estadounidense o tarjeta verde?",
      "hasSpentSubstantialTimeInUS": "¿Ha pasado más de 90 días al año en los Estados Unidos?",
      "isUSResidentForAnyOtherReason": "¿Tiene propiedades en los Estados Unidos?",
      "errors": {
        "firstName": "El nombre es obligatorio",
        "lastName": "El apellido es obligatorio",
        "nationalityIsoCode": "La nacionalidad es obligatoria",
        "residenceCountryIsoCode": "El país es obligatorio",
        "workplaceCountryIsoCode": "El lugar de trabajo es obligatorio",
        "birthDate": "La fecha de nacimiento es obligatoria y debe ser válida",
        "birthDateFuture": "La fecha de nacimiento no puede ser posterior a hoy",
        "cityOfBirth": "La ciudad de nacimiento obligatoria",
        "countryOfBirthIsoCode": "El país de nacimiento es obligatorio",
        "addressLine1": "La dirección es obligatoria",
        "zipCode": "El código postal es obligatorio",
        "city": "La ciudad es obligatoria",
        "activityId": "La actividad es obligatoria",
        "taxationCountryIsoCode": "El país de imposición es obligatorio",
        "isPoliticallyExposed": "Este campo es obligatorio",
        "isDirector": "Este campo es obligatorio",
        "percentageOfOwnership": "El porcentaje de propiedad es obligatorio",
        "percentageOfOwnershipInteger": "El porcentaje de propiedad debe ser un número entero",
        "percentageOfOwnershipRange": "El porcentaje de propiedad debe estar comprendido entre 0 y 100",
        "signature": "La firma es obligatoria",
        "passportNumber": "El número de pasaporte es obligatorio",
        "passportExpirationDate": "El pasaporte debe tener una fecha de caducidad válida",
        "passportExpirationDateOutdated": "La fecha debe ser mayor que la de hoy",
        "isLinkedToUnitedStates": "Este campo es obligatorio",
        "hasUSPassportOrGreenCard": "Este campo es obligatorio",
        "hasSpentSubstantialTimeInUS": "Este campo es obligatorio",
        "isUSResidentForAnyOtherReason": "Este campo es obligatorio",
        "mobilePhoneNumber": "El teléfono móvil es obligatorio y debe ser válido (ej: +41XXXXXXXXX)",
        "email": "El correo electrónico es obligatorio",
        "emailValid": "El correo electrónico debe ser válido",
        "tinNumber": "El número NIF es obligatorio"
      }
    },
    "companyTransaction": {
      "title": "Promedio mensual de transacciones de la empresa para {displayName}",
      "subtitle": {
        "incomingTransfer": "Transferencias entrantes",
        "outgoingTransfer": "Transferencias salientes"
      },
      "averageAmountOfIncomingTransfer": "Volumen de transferencias entrantes",
      "averageAmountOfIncomingTransferCurrencyIsoCode": "Moneda",
      "averageAmountOfOutgoingTransfer": "Volumen de transferencias salientes",
      "averageAmountOfOutgoingTransferCurrencyIsoCode": "Moneda",
      "numberOfIncomingTransferPerMonth": "Número de transferencias / mes",
      "numberOfOutgoingTransferPerMonth": "Número de transferencias / mes",
      "errors": {
        "averageAmountOfIncomingTransfer": "El volumen de transferencias entrantes es obligatorio",
        "averageAmountOfIncomingTransferNumber": "El volumen de transferencias entrantes debe ser un número",
        "averageAmountOfIncomingTransferCurrencyIsoCode": "La moneda es obligatoria",
        "averageAmountOfOutgoingTransfer": "El volumen de transferencias salientes es obligatorio",
        "averageAmountOfOutgoingTransferNumber": "El volumen de transferencias salientes debe ser un número",
        "averageAmountOfOutgoingTransferCurrencyIsoCode": "La moneda es obligatoria",
        "numberOfIncomingTransferPerMonth": "La cantidad de transferencias es obligatoria",
        "numberOfIncomingTransferPerMonthInteger": "La cantidad de transferencias debe ser un número",
        "numberOfOutgoingTransferPerMonth": "La cantidad de transferencias es obligatoria",
        "numberOfOutgoingTransferPerMonthInteger": "La cantidad de transferencias debe ser un número"
      }
    },
    "companyCounterpartyList": {
      "transactions": "Transacciones",
      "noResults": "No se ha añadido ninguna transacción. Por favor, añada todas las contrapartes implicadas si es necesario.",
      "deleteModal": {
        "title": "¿Está seguro de que desea eliminar este quid pro quo?",
        "subtitle": "Está a punto de eliminar esta contraparte: {entityName}"
      },
      "listHeaders": {
        "companyName": "Contraparte",
        "nationalityIsoCode": "Nacionalidad",
        "funds": "Fondos",
        "goods": "Mercancías",
        "from": "Desde",
        "to": "Hacia",
        "hsCode": "HS Code",
        "operationType": "Tipo de operación",
        "cashFlowType": "Tipo de flujo de caja",
        "yearlyValuationAmount": "Ventas anuales",
        "fundTransferFromCountryIsoCode": "Fondos desde",
        "fundTransferToCountryIsoCode": "Fondos hacia",
        "commodityFromCountryIsoCode": "Productos desde",
        "commodityToCountryIsoCode": "Mercancías hacia"
      }
    },
    "companyCounterpartyEdit": {
      "title": "Información de contraparte",
      "companyName": "Nombre de la contraparte",
      "nationalityIsoCode": "Nacionalidad de la contraparte",
      "fundTransferFromCountry": "Transferencia de fondos desde",
      "fundTransferFromSwitzerland": "CIM Banque",
      "fundTransferToCountry": "Transferencia de fondos hacia",
      "fundTransferToSwitzerland": "CIM Banque",
      "commodityFromCountryIsoCode": "Origen de las mercancías",
      "commodityToCountryIsoCode": "Destino de las mercancías",
      "productType": "Tipo de mercancía",
      "hsCodeChapter": "HS Code Capítulo",
      "hsCode": "HS Code",
      "operationType": "Tipo de operación",
      "cashFlowType": "Tipo de flujo de caja",
      "yearlyValuationAmount": "Ventas anuales",
      "yearlyValuationCurrencyIsoCode": "Moneda",
      "bankName": "Nombre del banco",
      "errors": {
        "companyName": "El nombre de la contraparte es obligatorio",
        "nationalityIsoCode": "La nacionalidad es obligatoria",
        "fundTransferFromCountryIsoCode": "El origen de los fondos es obligatorio",
        "fundTransferToCountryIsoCode": "El destino de los fondos es obligatorio",
        "commodityFromCountryIsoCode": "El origen de las mercancías es obligatorio",
        "commodityToCountryIsoCode": "El destino de las mercancías es obligatorio",
        "productType": "El tipo de mercancía es obligatoria",
        "operationType": "El tipo de operación es obligatoria",
        "cashFlowType": "El tipo de flujo financiero es obligatorio",
        "yearlyValuationAmount": "Las cifras de ventas anuales son obligatorias",
        "yearlyValuationAmountNumber": "Las ventas anuales deben ser una cifra",
        "yearlyValuationCurrencyIsoCode": "La moneda es obligatoria",
        "bankName": "El nombre del banco es obligatorio"
      }
    },
    "underReview": {
      "title": "Gracias por su interés en CIM Banque.",
      "message": "Su cuenta está siendo revisada y nos pondremos en contacto con usted en breve. Si tiene alguna pregunta sobre su solicitud, no dude en <a href='https://www.cimbanque.com/fr/the-bank/contact-us/' target='_blank'>ponerse en contacto con nosotros</a>."
    },
    "refused": {
      "title": "Gracias por su interés en CIM Banque.",
      "message": "Sin embargo, lamentamos informarle de que no podemos continuar con su solicitud de apertura de cuenta."
    },
    "initialDeposit": {
      "title": "Su depósito inicial",
      "activateAccount": "Para activar su cuenta y recibir sus tarjetas de crédito, efectúe su depósito inicial (Mín. EUR/CHF/USD 5'000) desde <u>su cuenta de BANCA PERSONAL ACTUAL</u> en un plazo de 15 días.",
      "activateAccountCorporate": "Para activar su cuenta y recibir sus tarjetas de crédito, efectúe su depósito inicial (Mín. EUR/CHF/USD 10'000) desde <u>su cuenta de BANCA ACTUAL</u> en un plazo de 15 días.",
      "notice": "Tenga en cuenta que si no ingresa fondos en su cuenta en un plazo de 15 días, ésta se cerrará automáticamente."
    },
    "ibanTempo": {
      "name": "Nombre",
      "tempIban": "Número IBAN temporal",
      "swift": "Swift (BIC) Code",
      "bankAddress": "Dirección bancaria",
      "bank": {
        "name": "CIM BANQUE",
        "addressLine1": "RUE MERLE D'AUBIGNE 16",
        "addressLine2": "GENEVA 1211 - Switzerland",
        "swift": "CIMMCHGG"
      }
    }
  }
}
